import Vue from 'vue';
import { types } from '../../../store/rootTypes';
import store from '../../../store';

export const RecommendationEventBus = new Vue();

RecommendationEventBus.$on('clicked', (documentData) => {
  if (!documentData.documentDetails.recommendation.id) {
    return;
  }

  store.dispatch(
    types
      .recommendationBasedJournals
      .actions
      .recommendationClicked,
    { doc: documentData },
  );
});

RecommendationEventBus.$on('clicked-source', (documentData) => {
  if (!documentData.documentDetails.recommendation.id) {
    return;
  }

  store.dispatch(
    types
      .recommendationBasedJournals
      .actions
      .recommendationClickedSource,
    { doc: documentData },
  );
});
